import type { SdkDnd } from '@Pages/pageRuntime/sdk/types';
import {
  sdkMemberLoaders,
  suspendingModuleRead,
  type RuntimeLoad
} from '@Pages/pageRuntime/sdkMemberLoaders';

const dndLoader = sdkMemberLoaders.Dnd;

export function preloadSdkDnd(): Promise<void> {
  return dndLoader.preload().then(() => undefined);
}

export function prepareSdkDndForSource(
  sources: Array<string | null | undefined>,
  load: RuntimeLoad
): Promise<void> | null {
  if (!sources.some((source) => source && /\bDnd\b/.test(source))) {
    return null;
  }

  return load(dndLoader)?.then(() => undefined) ?? null;
}

const readDnd = suspendingModuleRead(dndLoader);

function requireSdkDnd(): SdkDnd {
  return readDnd().sdkDnd;
}

export const lazySdkDnd = new Proxy({} as SdkDnd, {
  get: (_target, property) => Reflect.get(requireSdkDnd(), property),
  has: (_target, property) => Reflect.has(requireSdkDnd(), property),
  ownKeys: () => Reflect.ownKeys(requireSdkDnd()),
  getOwnPropertyDescriptor: (_target, property) =>
    Reflect.getOwnPropertyDescriptor(requireSdkDnd(), property)
});
